import { FC, useContext } from 'react';
import { useAppDrawer } from '../AppDrawer/AppDrawerProvider';
import LogsLayout from './LogsLayout';
import { useLocation } from 'react-router-dom';
import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { FeatureFlagContext } from '../FeatureFlag/FeatureFlagProvider';

const ContextWrapper = (props) => {
    const drawerContext = useAppDrawer();
    const location = useLocation();
    const { pricingModulesState } = usePricingModulesState();
    const featureFlagContext = useContext(FeatureFlagContext);
    const systemMode = featureFlagContext?.[FEATURE_FLAGS_NAMES.SystemMode];

    if (systemMode === undefined) {
        return null;
    }

    return (
        <LogsLayout
            {...props}
            appDrawerContext={drawerContext}
            systemMode={systemMode}
            pricingModulesState={pricingModulesState}
            location={location}
        />
    );
};

const LogsWithContext: FC = ContextWrapper;

export default LogsWithContext;
